import React, { useState, useEffect } from 'react';
import { cn } from '../../utils/cn';

export interface MainNavProps {
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Children elements
   */
  children: React.ReactNode;
}

const MainNav: React.FC<MainNavProps> = ({ className = '', children }) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  // Enhanced scroll listener for smooth transition
  useEffect(() => {
    const handleScroll = () => {
      // Calculate scroll percentage for the first 100px (0 to 1)
      const scrollPercentage = Math.min(window.scrollY / 100, 1);
      setScrollProgress(scrollPercentage);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Calculate dynamic styles based on scroll
  const dynamicStyles = {
    backgroundColor: `rgba(1, 2, 14, ${0.95 + (scrollProgress * 0.05)})`,
    backdropFilter: `blur(${8 + (scrollProgress * 4)}px)`,
    boxShadow: scrollProgress > 0.1 
      ? `0 4px 24px rgba(0, 0, 0, ${0.2 + (scrollProgress * 0.3)})` 
      : 'none',
  };

  return (
    <nav 
      style={dynamicStyles}
      className={cn(
        "fixed top-0 left-0 right-0 z-40 h-16 transition-all duration-200",
        "border-b border-white/5",
        className
      )}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-between items-center h-full">
          {children}
        </div>
      </div>
    </nav>
  );
};

export default MainNav; 